import { Client } from "@/Common/Api/Client";
import { BaseReactComponent } from "@/Common/Components/BaseReactComponent";
import { Modal } from "@/Common/Components/Modals/Modal";
import { Locale } from "@/Common/Models/Localization/Locale";
import * as LocalPatientOperations from "@/Common/Operations/operations.patient.local";
import { FormAction } from "@/Patient/Components/MedicalNote/Actions/FormAction";
import { FormsNameEnum } from "@/Patient/Models/Forms/FormsNameEnum";
import { GenericForm } from "@/Patient/Models/Forms/GenericForm";

interface Gad7FormPopupProps {
    encounterId: string;
    patientContactFacetId: string;
    consultationDate: Date;
    onClose: () => void;
}

class Gad7FormPopup extends BaseReactComponent<Gad7FormPopupProps> {
    public componentDidMount(): void {
        this.setAcceptableLocales([Locale.en]);
    }

    public render(): JSX.Element {
        return (
            <Modal
                cssClass="popup"
                title={this.getString("AnxietyScreeningLabel")}
                showOverlay={true}
                fixedOverlayPosition
                showX={true}
                width={450}
                disableOverlayClose={true}
                onClose={() => this.props.onClose()}
                footer={this.renderGad7FormPopupFooter()}
            >
                <div>
                    {this.getString("PatientScoredThreeOrMoreOnGadTwoScaleLabel")}
                    <br /><br />
                    {this.getString("DoYouWishToOpenGadSevenQuestionnaireLabel")}
                </div>
            </Modal>
        );
    }

    private renderGad7FormPopupFooter(): JSX.Element {
        return (
            <div className="flex-container" style={{ "justifyContent": "flex-end" }}>
                <div>
                    <button
                        className="btn"
                        style={{ "width": "55px" }}
                        onClick={() => this.props.onClose()}
                    >
                        {this.getString("NoLabel")}
                    </button>
                </div>
                <div style={{ "marginLeft": "5px" }}>
                    <button
                        className="btn btn-primary"
                        style={{ width: "55px" }}
                        onClick={() => {
                            this.props.onClose();
                            this.openGad7Form();
                        }}
                    >
                        {this.getString("YesLabel")}
                    </button>
                </div>
            </div>
        );
    }

    private async openGad7Form(): Promise<void> {
        const form = GenericForm.fromRadPDFForm({
            formId: null,
            formName: FormsNameEnum.GadSevenEnglishCommon
        });

        const action = new FormAction();
        const patientFormsResponse = await action.getEncounterPatientForms(
            form.formName,
            this.props.encounterId,
            this.props.patientContactFacetId
        );

        const lastGad7Form = patientFormsResponse.PatientForms ?
            patientFormsResponse.PatientForms[patientFormsResponse.PatientForms.length - 1] : null;

        if (!lastGad7Form)
            sessionStore.dispatch(LocalPatientOperations.MedicalNote.CreateRadPdfForm, { form: form.formName });
        else
            Client.openRadpdfForm(
                lastGad7Form.Id,
                sessionStore.getCurrentEmployee().ContactFacetId,
                lastGad7Form.EncounterId,
                this.props.consultationDate,
                true,
                null
            );
    }
}

export { Gad7FormPopup };
